/**
 * In FRB We use only support these 43 timezones. These should be used as source of truth for everything
 */
export enum TIMEZONES {
  'America/Anchorage' = 'America/Anchorage',
  'America/Caracas' = 'America/Caracas',
  'America/Chicago' = 'America/Chicago',
  'America/Denver' = 'America/Denver',
  'America/Halifax' = 'America/Halifax',
  'America/Los_Angeles' = 'America/Los_Angeles',
  'America/New_York' = 'America/New_York',
  'America/Mexico_City' = 'America/Mexico_City',
  'America/Sao_Paulo' = 'America/Sao_Paulo',
  'America/St_Johns' = 'America/St_Johns',
  'Asia/Almaty' = 'Asia/Almaty',
  'Asia/Baghdad' = 'Asia/Baghdad',
  'Asia/Bangkok' = 'Asia/Bangkok',
  'Asia/Dubai' = 'Asia/Dubai',
  'Asia/Hong_Kong' = 'Asia/Hong_Kong',
  'Asia/Kabul' = 'Asia/Kabul',
  'Asia/Kathmandu' = 'Asia/Kathmandu',
  'Asia/Kolkata' = 'Asia/Kolkata',
  'Asia/Magadan' = 'Asia/Magadan',
  'Asia/Riyadh' = 'Asia/Riyadh',
  'Asia/Shanghai' = 'Asia/Shanghai',
  'Asia/Singapore' = 'Asia/Singapore',
  'Asia/Tehran' = 'Asia/Tehran',
  'Asia/Tokyo' = 'Asia/Tokyo',
  'Asia/Yekaterinburg' = 'Asia/Yekaterinburg',
  'Asia/Yerevan' = 'Asia/Yerevan',
  'Atlantic/Azores' = 'Atlantic/Azores',
  'Atlantic/South_Georgia' = 'Atlantic/South_Georgia',
  'Australia/Brisbane' = 'Australia/Brisbane',
  'Australia/Darwin' = 'Australia/Darwin',
  'Australia/Sydney' = 'Australia/Sydney',
  'EET' = 'EET',
  'Europe/Amsterdam' = 'Europe/Amsterdam',
  'Europe/Istanbul' = 'Europe/Istanbul',
  'Europe/London' = 'Europe/London',
  'Europe/Paris' = 'Europe/Paris',
  'Europe/Stockholm' = 'Europe/Stockholm',
  'Indian/Cocos' = 'Indian/Cocos',
  'Pacific/Fiji' = 'Pacific/Fiji',
  'Pacific/Honolulu' = 'Pacific/Honolulu',
  'Pacific/Kwajalein' = 'Pacific/Kwajalein',
  'Pacific/Midway' = 'Pacific/Midway',
  'Pacific/Auckland' = 'Pacific/Auckland',
  'UTC' = 'UTC'
}
